import { getDataAsync } from "./PortalApi";
import DropdownValuesResponse from "interfaces/response/DropdownValuesResponse";

export const getDropdownValuesAsync = async(dropdownTableName: string) => {
  const routeUrl = `Fields/Options/${dropdownTableName}`;
  const response = await getDataAsync<DropdownValuesResponse[]>(routeUrl);
  
  return response;
}
